import React, { useContext } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import { SearchContext } from "@context/SearchContext";
import PlusIcon from "@components/Icons/PlusIcon";
import Button from "@components/Ui/Button";
import Loader from "@components/Ui/Loader";
import Drawer from "@components/V3/Drawer";
import Venues from "@components/V3/VenueSelector/venues";
import "./style.scss";

const VenueSelector = () => {
    const { venueName } = useContext(SearchContext);
    const { cinemas, cinemasLoading } = useContext(ApplicationContext);
    const { drawerState, openDrawer, closeDrawer } = useContext(AuthContext);

    return (
        <div className="venue-selector">
            <Button
                additionalClasses="venue-selector__button"
                onClick={() => openDrawer("venueSelectorDrawer")}
            >
                {venueName || "Add a cinema"}
                <PlusIcon className="venue-selector__icon" />
            </Button>

            {drawerState.venueSelectorDrawer && (
                <Drawer
                    id="venue-selector-drawer"
                    aria-label="Select your local cinema Drawer"
                    isOpen={drawerState.venueSelectorDrawer}
                    onClose={() => closeDrawer("venueSelectorDrawer")}
                    closeButtonAlignment="right"
                >
                    {cinemasLoading ? (
                        <Loader isLoading />
                    ) : (
                        <>
                            <Venues venues={cinemas} />
                            <Button
                                additionalClasses="button button__primary"
                                onClick={() => closeDrawer("venueSelectorDrawer")}
                            >
                                Save and browse
                            </Button>
                        </>
                    )}
                </Drawer>
            )}
        </div>
    );
};

export default VenueSelector;
